import classnames from 'classnames';
import React__default from 'react';
import { IconSize } from '../../lib/constants.js';
import { Button } from '../Button/index.js';
import { Icon as IconMemo } from '../Icon/index.js';
import ownClasses from './notice.module.scss.js';

const Notice = ({ children, variant, size, dark = false, icon, contentCentered = false, buttonConfiguration, closeConfiguration, classes = [], }) => {
    const content = typeof children !== 'string' ? (children) : (React__default.createElement("p", { className: `body-text ${size === 'small' ? 'small' : 'normal'}` }, children));
    return (React__default.createElement("article", { className: classnames(ownClasses.notice, ownClasses[`notice--${variant}--${dark ? 'solid' : 'lite'}`], {
            [ownClasses['content-centered']]: contentCentered,
            'theme-redCorporate': variant === 'error',
            'theme-yellowMarket': variant === 'alert',
            'theme-greenLavoro': variant === 'success',
            'theme-blueMotori': variant === 'informative',
        }, ...classes) },
        icon !== undefined ? (React__default.createElement(IconMemo, { name: icon, iconSize: size === 'small' ? IconSize.SM : IconSize.MD, fillColor: "currentColor", classes: [ownClasses['notice-icon']] })) : null,
        React__default.createElement("div", { className: classnames(ownClasses['content-wrapper']) }, content),
        buttonConfiguration !== undefined ? (React__default.createElement(Button, { design: dark ? 'outline-white' : 'solid', size: "medium", onClick: () => {
                buttonConfiguration.onClick();
            } }, buttonConfiguration.text)) : null,
        closeConfiguration !== undefined ? (React__default.createElement(Button, { design: "text", size: "small", onClick: () => {
                closeConfiguration.onClick();
            }, icon: React__default.createElement(IconMemo, { name: "Close" }) },
            React__default.createElement("span", { hidden: true, "aria-hidden": "false" }, "Chiudi"))) : null));
};

export { Notice };
//# sourceMappingURL=index.js.map
